import {
  GroupedSection,
  GroupSectionType,
  Task,
  TaskType,
} from '@griply/types';

const TYPE_LABELS: Record<string, string> = {
  [TaskType.Task]: 'Tasks',
  [TaskType.Habit]: 'Habits',
  [TaskType.Repeating]: 'Recurring',
};

const TYPE_ORDER = [TaskType.Task, TaskType.Habit, TaskType.Repeating];

export const groupTasksByType = (tasks: Task[]): GroupedSection[] => {
  const groupMap = new Map<string, Task[]>();

  for (const type of TYPE_ORDER) {
    groupMap.set(type, []);
  }

  for (const task of tasks) {
    const group = groupMap.get(task.type);
    if (group) {
      group.push(task);
    }
  }

  const sections: GroupedSection[] = [];

  for (const type of TYPE_ORDER) {
    const taskList = groupMap.get(type);
    if (!taskList?.length) {
      continue;
    }

    sections.push({
      sectionId: type,
      sectionType: GroupSectionType.Type,
      name: TYPE_LABELS[type] ?? type,
      tasks: taskList,
    });
  }

  return sections;
};
